var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInboxActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5C16.8284 5 18.2424 5.00023 19.1211 5.87891C19.9998 6.75759 20 8.17157 20 11V13C20 15.8284 19.9998 17.2424 19.1211 18.1211C18.2424 18.9998 16.8284 19 14 19H8C5.17157 19 3.75759 18.9998 2.87891 18.1211C2.00023 17.2424 2 15.8284 2 13V11C2 8.17157 2.00023 6.75759 2.87891 5.87891C3.75759 5.00023 5.17157 5 8 5H14ZM17.832 8.44531C17.5257 7.98578 16.9048 7.86162 16.4453 8.16797L11 11.7979L5.55469 8.16797L5.4668 8.11523C5.01884 7.8782 4.45515 8.01454 4.16797 8.44531C3.88068 8.87624 3.97184 9.44921 4.36328 9.77148L4.44531 9.83203L9.89062 13.4619L10.0186 13.541C10.6707 13.9085 11.4795 13.8818 12.1094 13.4619L17.5547 9.83203C18.0142 9.52568 18.1384 8.90484 17.832 8.44531Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxActive);
export default __webpack_public_path__ + "static/media/InboxActive.6dba14dabe79665b60b003b254b262ef.svg";
export { ForwardRef as ReactComponent };